import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const TESTID = 'icon-checkmark';
export const CheckmarkIcon = ({ fill = 'gcBlue', size = 'small' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox={'0 0 32 32'}
            data-testid={TESTID}
        >
            <path
                className={fillStyles}
                d="M4.11 10L.293 6.297c-.39-.379-.39-.994 0-1.374.391-.379 1.025-.379 1.416 0L4.11 7.252 11.29.285c.392-.38 1.025-.38 1.416 0 .392.379.392.994 0 1.374L4.11 10z"
                fillRule="evenodd"
            />
        </svg>
    );
};
CheckmarkIcon.TEST_ID = TESTID;
